// extracted by mini-css-extract-plugin
export default {"loader":"CRjz3Aeon9jwfn2Wfc3e"};